export default __webpack_public_path__ + "static/media/ampliTeach.1f900ee2.svg";